// extracted by mini-css-extract-plugin
module.exports = {"textSkeleton":"text-skeleton_textSkeleton__y1TwC","shimmer":"text-skeleton_shimmer__wO8sQ"};